import http from "./http";

export async function isNetNormal() {
    try {
        const res = await http.get("", { timeout: 3000 });
        console.log(res);
        return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error('isNetNormal error = ', error);
        if (error && (error.errCode === 'ERR_NETWORK' || error.errCode === 'ECONNABORTED')) {
            console.log("请求后台无网", error);
            return false;
        }
        return true;
    }
}

export async function uploadRecord(params: unknown) {
    try {
        const res = await http.post<string>("/api/auth/record-server/sync/endSide/record", params);
        return res.data;
    } catch (e) {
        console.log('uploadRecord error >>> ', e);
        return undefined;
    }
}

export async function updateRecordAudio(streamName: string, url: string) {
    try {
        await http.post<boolean>("/api/auth/record-server/sync/endSide/audioFile",
            { streamName, pcmFileKey: url });
        return true;
    } catch (e) {
        console.log("updateRecordAudio error >>>> ", e);
        return false;
    }
}